const GENERIC_SIGN_DOC_TITLE = 'Решениe о выпуске';

export const getSignDocName = (id: number, isSiq = false) =>
  `${GENERIC_SIGN_DOC_TITLE} №${id}`;
